import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50046478"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" a sample CSV template to see the required format. ")
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Import")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "descriptions-title" }, " Result counts based on current filters ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Fulfilled", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Unfulfilled", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "InReview", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Approved", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Rejected", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Cancel", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Partially Fulfilled", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "Hold", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cell-item" }, "All", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_filter_table = _resolveComponent("filter-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_list = _resolveComponent("list")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    onActionCreate: _cache[7] || (_cache[7] = ($event: any) => (
    _ctx.router.push({
      name: 'seller.orders-warehouse.add',
      params: {},
    })
    )),
    onActionImport: _ctx.showModalImport,
    onActionExport: _ctx.showModalExport
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.isShowModalImport,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowModalImport) = $event)),
        title: "Import Orders"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowModalImport = false))
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onSubmitImport
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_UploadFiles, {
            onOnChangeFiles: _ctx.onChangeFiles,
            multiple: false,
            accept: ".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }, null, 8, ["onOnChangeFiles"]),
          _createElementVNode("p", null, [
            _createVNode(_component_router_link, {
              to: { path: '/' },
              class: "text-blue-600"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _hoisted_2
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_filter_table, { onOnFilterCallback: _ctx.onSearchOrder }, null, 8, ["onOnFilterCallback"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 18,
                class: "mb-4 flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.fulfillValue,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fulfillValue) = $event)),
                    placeholder: "Fulfillment status",
                    class: "mx-2",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "default-first-option": "",
                    onChange: _ctx.filterByFulfillStatus,
                    multiple: "",
                    "collapse-tags": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fulfillmentStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          class: "mx-2",
                          placeholder: "Fulfillment status",
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]),
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.sourceValue,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sourceValue) = $event)),
                    placeholder: "Source",
                    filterable: "",
                    remote: "",
                    class: "mx-2",
                    "reserve-keyword": "",
                    "default-first-option": "",
                    onChange: _ctx.filterBySource
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          placeholder: "Source",
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"]),
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.dateFilter,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateFilter) = $event)),
                    type: "daterange",
                    "range-separator": "-",
                    "start-placeholder": "Start date",
                    "end-placeholder": "End date",
                    onChange: _ctx.onChangeDate,
                    format: "YYYY/MM/DD",
                    "value-format": "YYYY/MM/DD"
                  }, null, 8, ["modelValue", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_descriptions, {
                    class: "margin-top",
                    title: "",
                    column: 4,
                    size: _ctx.small,
                    border: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_8
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Fulfilled
                  ? _ctx.countOrderByStatus?.Fulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_9
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "primary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Unfulfilled
                  ? _ctx.countOrderByStatus?.Unfulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Review ? _ctx.countOrderByStatus?.Review : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_11
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Approved
                  ? _ctx.countOrderByStatus?.Approved
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_12
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "error"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Rejected
                  ? _ctx.countOrderByStatus?.Rejected
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Cancel ? _ctx.countOrderByStatus?.Cancel : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_14
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "success"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.PartiallyFulfilled
                  ? _ctx.countOrderByStatus?.PartiallyFulfilled
                  : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_15
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, {
                            size: "small",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.countOrderByStatus?.Hold ? _ctx.countOrderByStatus?.Hold : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_descriptions_item, null, {
                        label: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_tag, { size: "small" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.totalOrder ? _ctx.totalOrder : 0), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["size"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { class: "my-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_list)
        ]),
        _: 1
      }),
      _createVNode(_component_pagination, {
        total: _ctx.totalOrder,
        pagination: _ctx.state.params.page,
        "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.params.page) = $event)),
        limit: _ctx.state.params.limit,
        "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.params.limit) = $event))
      }, null, 8, ["total", "pagination", "limit"])
    ]),
    _: 1
  }, 16, ["onActionImport", "onActionExport"]))
}